'use client';

import clsx from 'clsx';
import { PAGE_SECTION_BAND_ELEVATED, pageSectionShell } from '@/constants/pageSections';
import { Heading2 } from '@/components/section/headings';
import type { NavCategoryGroup } from '@/lib/routing/navTree';
import NavCategoryPanel from './NavCategoryPanel';

export type HubCategorySectionProps = {
  title: string;
  subtitle?: string;
  groups: readonly NavCategoryGroup[];
  /** Grid column layout token */
  layout?: 'two-col' | 'three-col' | 'masonry' | 'split-duo';
  descriptions?: Record<string, string>;
  headingId?: string;
  className?: string;
};

const layoutClass: Record<NonNullable<HubCategorySectionProps['layout']>, string> = {
  'two-col': 'page-grid-2',
  'three-col': 'page-grid-3',
  masonry: 'page-grid-masonry',
  'split-duo': 'page-grid-2',
};

const HubCategorySection: React.FC<HubCategorySectionProps> = ({
  title,
  subtitle,
  groups,
  layout = 'three-col',
  descriptions = {},
  headingId = 'hub-categories',
  className,
}) => (
  <section
    className={clsx(pageSectionShell(PAGE_SECTION_BAND_ELEVATED), className)}
    aria-labelledby={headingId}
  >
    <div className="page-heading-wrap">
      <div id={headingId}>
        <Heading2
          title={title}
          subtitle={subtitle}
          titleClassName="text-prose"
          subtitleClassName="mt-3 text-prose-muted"
        />
      </div>
    </div>
    <div className={clsx('page-content-grid', layoutClass[layout])}>
      {groups.map((group) => (
        <NavCategoryPanel
          key={group.href}
          group={group}
          description={descriptions[group.href]}
          density={layout === 'split-duo' ? 'full' : 'compact'}
        />
      ))}
    </div>
  </section>
);

export default HubCategorySection;
